module.exports = __webpack_public_path__ + "static/media/icon-table.adf33a3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/icon-table.svg
// module id = 350
// module chunks = 0